import { createContext } from 'react';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetReporteesV2GetReporteesDto as ReporteesDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { Loadable } from '../../types';

export type ReporteesContextType = {
  data: Loadable<ReporteesDto[]>;
  callApi: () => void;
};

export const ReporteesContext = createContext<ReporteesContextType>({
  data: {
    loading: false,
    result: null,
    error: null,
  },
  callApi: () => {},
});
